import { render } from "./VentBotProject.vue?vue&type=template&id=7b192279&scoped=true"
import script from "./VentBotProject.vue?vue&type=script&lang=js"
export * from "./VentBotProject.vue?vue&type=script&lang=js"

import "./VentBotProject.vue?vue&type=style&index=0&id=7b192279&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b192279"]])

export default __exports__